import React from 'react';
import PropTypes from 'prop-types';
import { FlexColumn, Gap } from 'ui-components/components/flex';

import { PrinterDropdown } from './printer-dropdown';
import { ScaleDropdown } from './scale-dropdown';

import style from './printer-scale-dropdowns.module.less';

export const PrinterScaleDropdowns = ({ inactive = false }) => (
  <FlexColumn className={style['printer-scale-dropdowns']} gap={Gap.Space4}>
    <ScaleDropdown inactive={inactive} />
    <PrinterDropdown inactive={inactive} />
  </FlexColumn>
);

PrinterScaleDropdowns.propTypes = {
  inactive: PropTypes.bool,
};
